import ExlyImage from "common/Components/ExlyImage";
import constants from "constants/constants";
import React from "react";

export const getLocationOptions = ({ liveFeatures, scheduleType }) => [
  {
    id: constants.address_type_enum.exly_connect_by_zoom,
    label: "Exly Zoom",
    value: constants.address_type_enum.exly_connect_by_zoom,
    icon: (
      <ExlyImage
        alt="Exly Zoom"
        width="24px"
        src={require("assets/images/exly_con.png")}
      />
    ),
    hide: !liveFeatures?.is_exlycon_active,
  },
  {
    id: constants.address_type_enum.exly_zoom_webinar,
    label: "Exly Zoom Webinar",
    value: constants.address_type_enum.exly_zoom_webinar,
    icon: (
      <ExlyImage
        alt="Exly Zoom"
        width="24px"
        src={require("assets/images/exly_con.png")}
      />
    ),
    hide:
      scheduleType == constants.scheduleTypesId.one_on_one_appointment ||
      !liveFeatures?.is_exlycon_active,
  },
  {
    id: constants.address_type_enum.meet,
    label: "Google Meet (link auto generated on booking)",
    value: constants.address_type_enum.meet,
    icon: (
      <ExlyImage
        alt="Google Meet (link auto generated on booking)"
        width="24px"
        src={require("assets/images/meet_icon.png")}
      />
    ),
    hide: scheduleType === constants.scheduleTypesId.webinar,
  },
  {
    id: constants.address_type_enum.zoom,
    label: "Zoom (link auto generated on booking)",
    value: constants.address_type_enum.zoom,
    icon: (
      <ExlyImage
        alt="Zoom (link auto generated on booking)"
        width="24px"
        src={require("assets/images/zoom_icon.png")}
      />
    ),
  },
  {
    id: constants.address_type_enum.zoom_webinar,
    label: "Zoom Webinar",
    value: constants.address_type_enum.zoom_webinar,
    icon: (
      <ExlyImage
        alt="Zoom Webinar"
        width="24px"
        src={require("assets/images/zoom_icon.png")}
      />
    ),
    hide: scheduleType !== constants.scheduleTypesId.webinar,
  },
  {
    id: constants.address_type_enum.joining_link,
    label: "Online Meeting Link (Zoom, Meet, Skype, etc)",
    value: constants.address_type_enum.joining_link,
    icon: (
      <ExlyImage
        alt="Online Meeting Link (Zoom, Meet, Skype, etc)"
        width="20x"
        src={require("assets/images/online-meeting.png")}
      />
    ),
  },
  {
    id: constants.address_type_enum.personal_address,
    label: "At my personal address",
    value: constants.address_type_enum.personal_address,
    icon: (
      <ExlyImage
        alt="At personal address"
        width="20px"
        src={require("assets/images/personal-address.png")}
      />
    ),
    hide: scheduleType === constants.scheduleTypesId.webinar,
  },
  {
    id: constants.address_type_enum.customer_location,
    label: "At customer's address",
    value: constants.address_type_enum.customer_location,
    icon: (
      <ExlyImage
        alt="At customer's address"
        width="18px"
        src={require("assets/images/customer-address.png")}
      />
    ),
    hide: scheduleType === constants.scheduleTypesId.webinar,
  },
  {
    id: constants.address_type_enum.phone,
    label: "Phone",
    value: constants.address_type_enum.phone,
    icon: (
      <ExlyImage
        alt="Phone"
        width="24px"
        src={require("assets/images/phone.png")}
      />
    ),
    hide: scheduleType === constants.scheduleTypesId.webinar,
  },
  {
    id: constants.address_type_enum.whatsapp,
    label: "WhatsApp",
    value: constants.address_type_enum.whatsapp,
    icon: (
      <ExlyImage
        alt="Whatsapp"
        width="24px"
        src={require("assets/images/whatsapp.png")}
      />
    ),
    hide: scheduleType === constants.scheduleTypesId.webinar,
  },
];

export const phone_field_names_based_on_address_types = {
  [constants.address_type_enum.phone]: "venue_details.contact_number",
  [constants.address_type_enum.whatsapp]: "venue_details.whatsapp_link",
};
